import React, { useState } from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

const TransactionSearch = () => {
  return (
    <>
      <div className="listSearch border p-1 pe-5 rounded-3 position-relative">
        <div className="d-flex gap-2 flex-wrap align-items-center">
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 fw-medium d-flex align-items-center d-flex align-items-center">
              Type
            </span>
            <UncontrolledDropdown group>
              <DropdownToggle
                size="sm"
                color="info"
                className="shadow-none d-flex justify-content-center align-items-center rounded-0 rounded-end-3 px-2 py-2"
              >
                Any
                <i className=" bx bx-chevron-down fs-18"></i>
              </DropdownToggle>
              <DropdownMenu>
                <div className="form-check mb-1 d-flex align-items-center justify-content-center ps-0">
                  <label className="form-check-label fs-14 fw-normal">
                    <input
                      id="is-multiple"
                      name="isMultiple"
                      type="checkbox"
                      className="form-check-input"
                      value="false"
                      style={{ marginTop: -1 }}
                    />
                    <span className="pt-1">Some Action</span>
                  </label>
                </div>
                <div className="form-check mb-1 d-flex align-items-center justify-content-center ps-0">
                  <label className="form-check-label fs-14 fw-normal">
                    <input
                      id="is-multiple"
                      name="isMultiple"
                      type="checkbox"
                      className="form-check-input"
                      value="false"
                      style={{ marginTop: -1 }}
                    />
                    <span className="pt-1">Some Action</span>
                  </label>
                </div>
                <div className="form-check mb-1 d-flex align-items-center justify-content-center ps-0">
                  <label className="form-check-label fs-14 fw-normal">
                    <input
                      id="is-multiple"
                      name="isMultiple"
                      type="checkbox"
                      className="form-check-input"
                      value="false"
                      style={{ marginTop: -1 }}
                    />
                    <span className="pt-1">Some Action</span>
                  </label>
                </div>
                <DropdownItem divider />
                <div className="form-check mb-1 d-flex align-items-center justify-content-center ps-0">
                  <label className="form-check-label fs-14 fw-normal">
                    <input
                      id="is-multiple"
                      name="isMultiple"
                      type="checkbox"
                      className="form-check-input"
                      value="false"
                      style={{ marginTop: -1 }}
                    />
                    <span className="pt-1">Some Action</span>
                  </label>
                </div>
                <div className="form-check mb-1 d-flex align-items-center justify-content-center ps-0">
                  <label className="form-check-label fs-14 fw-normal">
                    <input
                      id="is-multiple"
                      name="isMultiple"
                      type="checkbox"
                      className="form-check-input"
                      value="false"
                      style={{ marginTop: -1 }}
                    />
                    <span className="pt-1">Some Action</span>
                  </label>
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 fw-medium d-flex align-items-center">
              Status
            </span>
            <div className="bg-info text-white position-relative rounded-end-3">
              <select
                className="border-0 form-control fs-13 p-0 bg-info text-white rounded-0 rounded-end-3 px-2 pe-4 py-2"
                aria-label="Default select example"
              >
                <option className="1">Enable</option>
                <option className="2">Disable</option>
              </select>
              <i className=" bx bx-chevron-down fs-18 position-absolute top-50 end-0 translate-middle-y me-2"></i>
            </div>
          </div>
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 fw-medium d-flex align-items-center">
              Created By
            </span>
            <div className="bg-info text-white position-relative rounded-end-3">
              <select
                className="border-0 form-control fs-13 p-0 bg-info text-white rounded-0 rounded-end-3 px-2 pe-4 py-2"
                aria-label="Default select example"
              >
                <option className="1">Enable</option>
                <option className="2">Disable</option>
              </select>
              <i className=" bx bx-chevron-down fs-18 position-absolute top-50 end-0 translate-middle-y me-2"></i>
            </div>
          </div>
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 fw-medium d-flex align-items-center">
              Updated By
            </span>
            <div className="bg-info text-white position-relative rounded-end-3">
              <select
                className="border-0 form-control fs-13 p-0 bg-info text-white rounded-0 rounded-end-3 px-2 pe-4 py-2"
                aria-label="Default select example"
              >
                <option className="1">Enable</option>
                <option className="2">Disable</option>
              </select>
              <i className=" bx bx-chevron-down fs-18 position-absolute top-50 end-0 translate-middle-y me-2"></i>
            </div>
          </div>
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 fw-medium d-flex align-items-center">
              Updated Byyy
            </span>
            <span className="divideSection position-relative p-1 d-flex align-items-center">
              <select
                className="border-0 form-control fs-11 fw-bold p-0 bg-white rounded-5 px-2 py-1 position-relative z-1"
                aria-label="Default select example"
              >
                <option className="1">Enable</option>
                <option className="2">Disable</option>
              </select>
            </span>
            <div className="bg-info text-white position-relative rounded-end-3">
              <select
                className="border-0 form-control fs-13 p-0 bg-info text-white rounded-0 rounded-end-3 px-2 pe-4 py-2"
                aria-label="Default select example"
              >
                <option className="1">Enable</option>
                <option className="2">Disable</option>
              </select>
              <i className=" bx bx-chevron-down fs-18 position-absolute top-50 end-0 translate-middle-y me-2"></i>
            </div>
          </div>
          <div className="listSearchContain bg-light rounded-3 lh-1 d-flex">
            <span className="px-2 fs-13 text-nowrap fw-medium d-flex align-items-center">
              Updated at
            </span>
            <Flatpickr
              className="border-0 form-control fs-13 p-0 bg-info text-white rounded-0 rounded-end-3 px-2 py-2"
              options={{
                mode: 'range',
                dateFormat: 'Y-m-d',
                defaultDate: ['01 Jan 2022'],
              }}
            />
          </div>
          <input
            type="text"
            placeholder="Type to search for entries"
            className="border-0 form-control fs-13"
            style={{ width: 320 }}
          />
        </div>

        <div className="position-absolute top-0 end-0 m-1 p-2">
          <i className="ri-filter-3-line"></i>
        </div>
      </div>

      <ul className="list-unstyled d-flex gap-2 fs-13 mt-3">
        <li className="border border-dashed px-2 py-1 rounded-5 lh-1 cursor-pointer">
          <i className="ri-add-circle-line"></i> Updated By
        </li>
        <li className="border border-dashed px-2 py-1 rounded-5 lh-1 cursor-pointer">
          <i className="ri-add-circle-line"></i> Created By
        </li>
        <li className="border border-dashed px-2 py-1 rounded-5 lh-1 cursor-pointer">
          <i className="ri-add-circle-line"></i> Status
        </li>
        <li className="border border-dashed px-2 py-1 rounded-5 lh-1 cursor-pointer">
          <i className="ri-add-circle-line"></i> Updated Byyy
        </li>
        <li className="border border-dashed px-2 py-1 rounded-5 lh-1 cursor-pointer">
          <i className="ri-add-circle-line"></i> Updated at
        </li>
      </ul>
    </>
  );
};

export default TransactionSearch;
